import { ComponentProps, HTMLAttributes, ReactNode } from 'react'

import { Tooltip } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../_providers/TranslationProvider.client'

import * as Styles from './ColorGroupTooltip.styles'

type ColorGroupTooltipProps = {
  /** The content to render in the tooltip. See `ColorGroupTooltipContent`. */
  content: ReactNode
  /** Optionally define the inner content for the tooltip trigger. Defaults to our `Info` icon. */
  children?: ReactNode
} & Omit<ComponentProps<typeof Tooltip>, 'children' | 'content'>

/** The top-level component for rendering a tooltip for a given color group. */
export function ColorGroupTooltip({
  content,
  children = <Styles.InfoIcon />,
  ...rest
}: ColorGroupTooltipProps) {
  const translations = useTranslation()
  return (
    <Tooltip content={content} {...rest}>
      <button aria-label={translations.detailsSection.additionalColorInformation}>
        {children}
      </button>
    </Tooltip>
  )
}

type ColorGroupTooltipContentProps = {
  /** The title content for the tooltip. */
  title: ReactNode
  /** The description content of the tooltip. */
  description: ReactNode
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

/* The content of the color group tooltip. Expected to be provided to the `content` prop of `ColorGroupTooltip`. */
export function ColorGroupTooltipContent({
  title,
  description,
  ...rest
}: ColorGroupTooltipContentProps) {
  return (
    <Styles.TooltipContent {...rest}>
      {title}
      {description}
    </Styles.TooltipContent>
  )
}

/** The title for the color group tooltip. Expected to be provided to the `title` prop of `ColorGroupTooltipContent`*/
export const ColorGroupTooltipTitle = Styles.TooltipTitle
/** The description for the color group tooltip. Expected to be provided to the `description` prop of `ColorGroupTooltipContent`*/
export const ColorGroupTooltipDescription = Styles.TooltipDescription
